"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../constants");
const formatDate = (value, { withTime = true, emptyValue = constants_1.EMPTY_TEXT.dash, format: customFormat, } = {}) => {
    if (value === '') {
        return emptyValue;
    }
    const momentDate = moment_1.default(value);
    const format = customFormat || `MM/DD/YYYY${withTime ? ' h:mm:ss A' : ''}`;
    return momentDate.format(format);
};
exports.formatDate = formatDate;
//# sourceMappingURL=formatDate.js.map